import React, { useState } from "react";
import { Card } from "../components/ui/card";
import { ArrowUp, ArrowDown, Minus } from "lucide-react";
import { PolarityBadge, WarStanceBadge } from "./StanceBadge";
import StatementDetail from "./StatementDetail";
import {
  EMOTION_LABELS_TR, EMOTION_COLORS, EMOTION_EMOJI, formatDateOnlyTR,
} from "../lib/constants";

function TrendIcon({ trend }) {
  if (trend === "up") return <ArrowUp className="h-3.5 w-3.5 text-red-500" />;
  if (trend === "down") return <ArrowDown className="h-3.5 w-3.5 text-green-500" />;
  return <Minus className="h-3.5 w-3.5 text-gray-500" />;
}

export default function CountryCards({ summaries, onRefreshCountry, refreshing }) {
  const [selected, setSelected] = useState(null);
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3" data-testid="country-cards-grid">
      {summaries.map((s) => {
        const last = s.last_statement;
        const dom = s.dominant_emotion;
        return (
          <Card key={s.code}
                className="rounded-sm bg-[#141414] border-white/10 p-4 hover:bg-[#1F1F1F] transition-colors cursor-pointer"
                onClick={() => last && setSelected(s)}
                data-testid={`country-card-${s.code}`}>
            <div className="flex items-start gap-3">
              <img src={s.flag_url} alt={s.name_tr}
                   className="h-9 w-12 object-cover rounded-sm border border-white/10" />
              <div className="min-w-0 flex-1">
                <div className="font-heading text-white text-base leading-tight truncate">{s.name_tr}</div>
                <div className="data-label mt-0.5">{s.code}</div>
              </div>
              <TrendIcon trend={s.trend} />
            </div>
            <div className="mt-3 flex items-center gap-2 flex-wrap">
              <PolarityBadge polarity={s.dominant_polarity} />
              <WarStanceBadge stance={s.dominant_war_stance} />
            </div>
            <div className="mt-3 grid grid-cols-2 gap-2 text-[11px] font-mono">
              <div>
                <div className="data-label">Baskın Duygu</div>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <span className="text-base leading-none">{dom ? EMOTION_EMOJI[dom] : "—"}</span>
                  <span style={{ color: dom ? EMOTION_COLORS[dom] : "#9CA3AF" }}>
                    {dom ? EMOTION_LABELS_TR[dom] : "—"}
                  </span>
                </div>
              </div>
              <div>
                <div className="data-label">Kayıt Sayısı</div>
                <div className="text-white text-base mt-0.5">{s.statement_count}</div>
              </div>
            </div>
            {last && (
              <div className="mt-3 text-xs text-gray-400 line-clamp-2 leading-snug">
                {last.headline_tr || last.summary_tr}
              </div>
            )}
            {last && (
              <div className="mt-2 data-label">{formatDateOnlyTR(last.statement_date)}</div>
            )}
          </Card>
        );
      })}
      <StatementDetail
        open={!!selected} onClose={() => setSelected(null)}
        country={selected || null}
        statement={selected?.last_statement || null}
        onRefresh={onRefreshCountry} refreshing={refreshing}
      />
    </div>
  );
}
